import { useAuthenticationService } from '~/common/services/AuthenticationService';
import { EmployeeKeys } from '~/common/api/zeiterfassungServerApi/EmployeeApi';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ID, unwrap } from '~/common/api/common/apiCommons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export function useVerifyToken() {
  const { authenticationState, logout } = useAuthenticationService();
  const token = authenticationState?.token;
  const navigate = useNavigate();
  return useQuery({
    queryKey: ['verifyToken'],
    queryFn: async () => {
      await axios
        .get('/auth/token/verify/', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .catch((res) => {
          console.log('Token verification failed', res);
          if (res.response.status === 401) {
            logout();
            navigate('/login');
          }
        });
    },
    enabled: !!token,
    refetchInterval: 1000 * 60,
  });
}

export function useLogoutUserByAdmin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (req: { employee_id: ID }) =>
      await axios.post<void>('/auth/admin/logout/user/', req).then(unwrap),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [EmployeeKeys.EMPLOYEES_STATUS],
      });
    },
  });
}
